import styled from 'styled-components'
import { FlexContainer } from '~/components/Layout'

export const StyledOrderSuccessful = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #ffffff;
  border-radius: 16px;
  border: 0.5px solid #e7e2ff;
  width: 435px;
  position: relative;

  ${({ theme }) => theme.media.sm`
    margin-bottom: 16px;
    width: 100%;
  `}
`

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  left: 0px;
  outline: none;
  position: absolute;
  top: 10px;
  transform: rotate(90deg);
`

export const Title = styled.div`
  box-shadow: inset 0px -1px 0px #eaecf6;
  color: #191c1e;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  padding: 14px 0;
  text-align: center;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 32px 20px 16px;
`

export const StyledShield = styled.img`
  width: 48px;
  height: 54px;
`

export const StyledIconSuccess = styled.img`
  width: 48px;
  height: 48px;
`

export const StyledDescWrapper = styled(FlexContainer)`
  width: 100%;
  height: 56px;
  padding: 8px 12px;
  border-radius: 12px;
  background: #e6f4fc;
`

export const StyledDesc = styled.p`
  color: #098de6;
  font-size: 12px;
  font-weight: 400;
`

export const StyledLearnMore = styled.a`
  color: #777a8c;
  font-size: 12px;
  font-weight: 500;

  &:hover {
    color: #777a8c;
  }
`

export const StyledStatusLabel = styled.span`
  margin-top: 8px;
  color: #34bd84;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`
